import { createClientConfig } from "@repo/design-system/lib/client-registry";
import { FilterbarEcon } from "~/components/job-board/subclients/econ/filterbar-econ";
import { JoblistEcon } from "~/components/job-board/subclients/econ/joblist-econ";
import { UnifiedJobPageTemplate } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import SocialSectionEcon from "~/components/job-page/subclients/econ/social-section-econ";
import HeaderMainEcon from "~/components/page-skeleton/subclients/econ/header-main-econ";
import { defaultTemplate } from "./default";

export const econ = createClientConfig({
  components: {
    JobpageTemplate: UnifiedJobPageTemplate,
    Filterbar: FilterbarEcon,
    Joblist: JoblistEcon,
    HeaderMain: HeaderMainEcon,
    /** Same module as subtemplate `socialSection` (./default.tsx); replaces default job-board `TeaserBar` slot. */
    TeaserBar: SocialSectionEcon,
  },
  ui: {
    searchSummaryEmpty: "E.ON Inhouse Consulting",
  },
  subtemplates: [defaultTemplate],
});
